import { IApiQueryOptions } from 'api/ApiClient';
import { ICreateUpdateDaySegmentRequest } from 'types';

export enum DaySegments {
  GET_DAY_SEGMENTS_REQUEST = '@daysegments/GET_DAY_SEGMENTS_REQUEST',
  GET_DAY_SEGMENTS_SUCCESS = '@daysegments/GET_DAY_SEGMENTS_SUCCESS',
  GET_DAY_SEGMENTS_FAIL = '@daysegments/GET_DAY_SEGMENTS_FAIL',

  CREATE_DAY_SEGMENT_REQUEST = '@daysegments/CREATE_DAY_SEGMENT_REQUEST',
  CREATE_DAY_SEGMENT_SUCCESS = '@daysegments/CREATE_DAY_SEGMENT_SUCCESS',
  CREATE_DAY_SEGMENT_FAIL = '@daysegments/CREATE_DAY_SEGMENT_FAIL',

  GENERATE_DAY_SEGMENTS_REQUEST = '@daysegments/GENERATE_DAY_SEGMENTS_REQUEST',
  GENERATE_DAY_SEGMENTS_SUCCESS = '@daysegments/GENERATE_DAY_SEGMENTS_SUCCESS',
  GENERATE_DAY_SEGMENTS_FAIL = '@daysegments/GENERATE_DAY_SEGMENTS_FAIL',

  REPLACE_DAY_SEGMENTS_REQUEST = '@daysegments/REPLACE_DAY_SEGMENTS_REQUEST',
  REPLACE_DAY_SEGMENTS_SUCCESS = '@daysegments/REPLACE_DAY_SEGMENTS_SUCCESS',
  REPLACE_DAY_SEGMENTS_FAIL = '@daysegments/REPLACE_DAY_SEGMENTS_FAIL',

  UPDATE_DAY_SEGMENT_REQUEST = '@daysegments/UPDATE_DAY_SEGMENT_REQUEST',
  UPDATE_DAY_SEGMENT_SUCCESS = '@daysegments/UPDATE_DAY_SEGMENT_SUCCESS',
  UPDATE_DAY_SEGMENT_FAIL = '@daysegments/UPDATE_DAY_SEGMENT_FAIL',

  DELETE_DAY_SEGMENT_REQUEST = '@daysegments/DELETE_DAY_SEGMENT_REQUEST',
  DELETE_DAY_SEGMENT_SUCCESS = '@daysegments/DELETE_DAY_SEGMENT_SUCCESS',
  DELETE_DAY_SEGMENT_FAIL = '@daysegments/DELETE_DAY_SEGMENT_FAIL',
}

export interface IGetDaySegmentOptions {
  siteId: string;
  options?: IApiQueryOptions;
}

export interface ICreateDaySegmentPayload {
  siteId: string;
  data: ICreateUpdateDaySegmentRequest;
  onSuccess?: () => void;
}

export interface IGenerateDaySegmentPayload {
  siteId: string;
  onSuccess?: (input: ICreateUpdateDaySegmentRequest[]) => void;
  onError?: (error: any) => void;
}

export interface IReplaceDaySegmentPayload {
  siteId: string;
  body: ICreateUpdateDaySegmentRequest[];
  onSuccess?: () => void;
}

export interface IUpdateDaySegmentPayload extends ICreateDaySegmentPayload {
  daySegmentId: string;
}

export interface IDeleteDaySegmentPayload {
  siteId: string;
  daySegmentId: string;
  onSuccess?: () => void;
}
